import { render, staticRenderFns } from "./IntegrationInformationUpdate.vue?vue&type=template&id=c21204aa&"
import script from "./IntegrationInformationUpdate.vue?vue&type=script&lang=js&"
export * from "./IntegrationInformationUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports